import React, {
  useRef,
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  SyntheticEvent,
} from "react";
import { StyleSettings } from "src/styles/StyleSettings";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { IconButton } from "@mui/material";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { getInitFormData, getTablebySql } from "@shared/utils/CommonUtils";
import SnTab from "@shared/components/SnTab";
import { Box, TextField, Typography, Stack } from "@mui/material";
import SnButton from "@shared/components/SnButton";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Checkbox from "@mui/material/Checkbox";
import MenuItem from "@mui/material/MenuItem";
import formGridColumn from "./JsonData/formGridColumn.json";
import headerCtrl from "./JsonData/headerCtrl.json";
import {
  TpColumnList,
  CellValueChangedEvent,
} from "@shared/components/GridV2/SnGridTypes";
import { TpCtrlList } from "@shared/type/CommonType";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  type: string;
  columnsData: any[];
  columnsData2: any[];
  gridData: any;
  modalRef?: any; // 부모 엘리먼트
  isPopup?: boolean;
}

const DesignerGridEdit = forwardRef(
  (
    {
      type,
      columnsData,
      columnsData2,
      gridData = {
        title: "",
        table: "",
      },
      modalRef,
      isPopup,
    }: Props,
    ref
  ) => {
    const gridApiRef = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const gridApiRef2 = useRef<any>(null); // 두 번째  그리드 Reference 변수
    const { userInfo } = global();
    const [girdcolumns, setGridColumns] = useState<any[]>([]);
    const [girdcolumns2, setGridColumns2] = useState<any[]>(
      headerCtrl.headerCtrl
    );
    const [parentref, setParentref] = useState<any>(null);
    const [parentref2, setParentref2] = useState<any>(null);

    const selectedTabPage = useRef<any>(1);
    const [form, setForm] = useState(gridData);
    const [options, setOptions] = useState<any[]>([]);
    const [initOption, setInitOption] = useState<any[]>(
      gridData.filterColumns || []
    );

    useEffect(() => {
      if (modalRef?.current) {
        setParentref(modalRef.current.getPopupParent());
        setParentref2(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const jscombocolumn = TpColumnList.map((v) => ({
        code: v,
        name: v,
      }));
      const jscomboctrl = TpCtrlList.map((v) => ({
        code: v,
        name: v,
      }));
      const newColumns = formGridColumn.formGridColumn.map((column: any) => {
        if (column.cd_column === "tp_column") {
          return {
            ...column,
            js_combo: jscombocolumn,
          };
        }
        return column;
      });
      setGridColumns(newColumns);
      const newColumns2 = headerCtrl.headerCtrl.map((column: any) => {
        if (column.cd_column === "tp_ctrl") {
          return {
            ...column,
            js_combo: jscomboctrl,
          };
        }
        return column;
      });
      setGridColumns2(newColumns2);
    }, []);

    useEffect(() => {
      const updatedData: any[] = [];
      columnsData.forEach((data) => {
        updatedData.push({ cd_column: data.cd_column });
      });
      setOptions(updatedData);
    }, [columnsData]);

    useImperativeHandle(ref, () => ({
      getSelectedRow: () => {
        gridApiRef.current.stopEditing();
        gridApiRef2.current.stopEditing();
        const updatedData: any[] = [];
        gridApiRef.current.forEachNode((node: any) => {
          updatedData.push(node.data);
        });
        const updatedData2: any[] = [];
        gridApiRef2.current.forEachNode((node: any) => {
          updatedData2.push(node.data);
        });
        return [updatedData, updatedData2, { ...form }];
      },
    }));

    const onGridBtnsClick = async (id: string) => {
      if (id == "addRow") {
        onAddRow();
      }
      if (id == "deleteRow") {
        onDeleteRow();
      }
      if (id == "addRow2") {
        onAddRow2();
      }
      if (id == "deleteRow2") {
        onDeleteRow2();
      }
    };
    const onAddRow = async () => {
      try {
        const line = gridApiRef.current.getMaxValue("no_line") + 1;
        const seq = gridApiRef.current.getMaxValue("no_seq") + 1;
        const newRow = {
          no_seq: seq,
          cd_firm: userInfo.cd_firm,
        };
        gridApiRef.current?.addRow(newRow);
      } catch (error: any) {}
    };

    const onDeleteRow = async () => {
      if (gridApiRef.current?.getDisplayedRowCount() < 1) {
        return;
      }
      gridApiRef.current?.deleteSelectedRows();
    };

    const onAddRow2 = async () => {
      try {
        const line = gridApiRef2.current.getMaxValue("no_line") + 1;
        const seq = gridApiRef2.current.getMaxValue("no_seq") + 1;
        const newRow = {
          no_line: line,
          no_seq: seq,
          cd_firm: userInfo.cd_firm,
        };
        gridApiRef2.current?.addRow(newRow);
      } catch (error: any) {}
    };

    const onDeleteRow2 = async () => {
      if (gridApiRef2.current?.getDisplayedRowCount() < 1) {
        return;
      }
      gridApiRef2.current?.deleteSelectedRows();
    };

    const search = async (value: string) => {
      const param = {
        id: "com_drawing_01",
        params: {
          cd_firm: userInfo.cd_firm,
          nm_column: value,
        },
      };

      const rtn: any = await fnGetDataSet(param);
      const seq = gridApiRef.current.getMaxValue("no_seq") + 1;
      const newrow = rtn[0][0];
      newrow.no_seq = seq;
      newrow.cd_firm = userInfo.cd_firm;
      gridApiRef.current?.addRow(newrow);
    };

    const addButton = async (value: string) => {
      const seq = gridApiRef2.current.getMaxValue("no_seq");
      value.split(",").map((btn, i) => {
        const trimmed = btn.trim();
        const newRow = {
          cd_firm: userInfo.cd_firm,
          tp_ctrl: "SnButton",
          qt_width: null,
          nm_label: trimmed,
          cd_value: null,
          tp_format: null,
          cd_param: trimmed,
          cd_clas: null,
          dc_sql: null,
          cd_popup: null,
          fg_visible: "Y",
          yn_required: "N",
          dc_editcon: null,
          cd_displaycolumn: null,
          dc_filter: null,
          no_seq: seq + 1 + i,
        }; // 빈 객체
        gridApiRef2.current?.addRow(newRow);
      });
    };

    const handleChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, checked } = e.target;
      setForm({ ...form, [name]: checked });
    };

    const onGridBtnClick = (key: string) => {
      if (key.includes("적용")) {
      } else alert(key);
    };

    const convertButton = (value: string) => {
      if (value == null || value == "") return null;
      const buttonLabels = value
        .split(",")
        .map((label) => label.trim())
        .filter((label) => label);

      const nodes = buttonLabels.map((label) => (
        <SnButton
          key={label}
          text={label}
          onClick={() => onGridBtnClick(label)}
        />
      ));
      return nodes;
    };

    const convertDefaultValue = (str: string) => {
      return str
        .split(",")
        .map((pair) => pair.trim())
        .filter(Boolean)
        .reduce(
          (acc, cur) => {
            const [key, value] = cur.split(":").map((s) => s.trim());
            if (key) acc[key] = value ?? "";
            return acc;
          },
          {} as Record<string, string>
        );
    };
    const setColumnsInfo = async () => {
      const columnsInfo = await getColumnsInfo(form.table);
      setForm({ ...form, columnsInfo: columnsInfo });
      if (columnsInfo && Array.isArray(columnsInfo)) {
        setOptions(columnsInfo);
      }
    };

    const getColumnsInfo = async (tablename: string) => {
      try {
        const search = {
          queryId: "getColumnsInfo",
          id: "DesignerMapper",
          params: {
            table_name: tablename,
          },
        };
        const data: any = await fnGetDataSet(search);
        return data[0];
      } catch (error) {}
    };

    const onTabChanged = (tabIndex: any) => {
      selectedTabPage.current = tabIndex;
    };

    const filterChange = (e: SyntheticEvent, value: any) => {
      const filterColumns = value.map((option: any) => option.column_name);
      setForm({ ...form, filterColumns: filterColumns });
      setInitOption(filterColumns);
    };

    const onCellDoubleClicked = (event: any) => {};

    const onCellValueChanged = (event: CellValueChangedEvent) => {
      if (event.colId == "cd_column") {
        const updatedData: any[] = [];
        gridApiRef.current.forEachNode((node: any) => {
          updatedData.push({ cd_column: node.data.cd_column });
        });
        setOptions(updatedData);
      }
    };

    return (
      <div>
        <SnTab
          titles={["컬럼", "그리드", "헤더"]}
          width={"100%"}
          onTabChanged={onTabChanged}
          body={[
            <div>
              <div className="w-[1438px] h-[600px]">
                <SnGrid
                  ref={gridApiRef} // Grid Name
                  columnConfig={girdcolumns} // 컬럼 설정 전달
                  rowData={
                    columnsData.length === 1 &&
                    Object.keys(columnsData[0]).length === 0
                      ? []
                      : columnsData
                  }
                  etcProps={{ popupParent: parentref }}
                  events={{
                    onBtnAddClick: onGridBtnClick,
                    onCellDoubleClicked: onCellDoubleClicked,
                    onCellValueChanged: onCellValueChanged,
                  }}
                />
              </div>
            </div>,
            <div>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 2,
                  p: 2,
                  border: "1px solid rgb(186,191,199)",
                  height: "100%",
                }}
              >
                <Typography sx={{ alignSelf: "center" }}>타이틀</Typography>
                <TextField
                  size="small"
                  name="title"
                  value={form.title}
                  onChange={handleChange}
                  fullWidth
                />

                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  행추가
                </Typography>
                <Checkbox
                  name="addrow"
                  checked={form.addrow}
                  onChange={handleCheckboxChange}
                />
                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  행삭제
                </Typography>
                <Checkbox
                  name="delrow"
                  checked={form.entertoAddrow}
                  onChange={handleCheckboxChange}
                />

                <Typography sx={{ alignSelf: "start", mt: 1 }}>
                  필터링
                </Typography>
                <Autocomplete
                  size="small"
                  multiple
                  options={options}
                  disableCloseOnSelect
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : (option?.cd_column ?? "")
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.cd_column === value.cd_column
                  }
                  value={options.filter((option: any) =>
                    initOption.includes(option.cd_column)
                  )}
                  onChange={filterChange}
                  renderOption={(props, option, { selected }) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li key={key} {...optionProps}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.cd_column}
                      </li>
                    );
                  }}
                  style={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Columns" />
                  )}
                />

                <Typography sx={{ alignSelf: "start", mt: 1 }}>
                  행선택모드
                </Typography>
                <TextField
                  name="rowselection"
                  select
                  value={form.rowselection}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="single">single</MenuItem>
                  <MenuItem value="multiple">multiple</MenuItem>
                </TextField>

                {/* ischeckboxSelection */}
                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  체크박스여부
                </Typography>
                <Checkbox
                  name="ischeckboxSelection"
                  checked={form.ischeckboxSelection}
                  onChange={handleCheckboxChange}
                />

                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  편집여부
                </Typography>
                <Checkbox
                  name="isEditable"
                  checked={form.isEditable}
                  onChange={handleCheckboxChange}
                />

                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  엔터로 행추가
                </Typography>
                <Checkbox
                  name="entertoAddrow"
                  checked={form.entertoAddrow}
                  onChange={handleCheckboxChange}
                />

                {/* rowGroupPanelShow */}
                <Typography sx={{ alignSelf: "start", mt: 2 }}>
                  그룹핑모드
                </Typography>
                <TextField
                  name="rowGroupPanelShow"
                  select
                  value={form.rowGroupPanelShow}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                >
                  <MenuItem value="onlyWhenGrouping">onlyWhenGrouping</MenuItem>
                  <MenuItem value="never">never</MenuItem>
                  <MenuItem value="always">always</MenuItem>
                </TextField>
                {/* 빈 칸 채우기 */}
              </Box>
            </div>,
            <div>
              <div className="w-[1438px] h-[600px]">
                <SnGrid
                  ref={gridApiRef2} // Grid Name
                  columnConfig={girdcolumns2} // 컬럼 설정 전달
                  rowData={
                    columnsData2.length === 1 &&
                    Object.keys(columnsData2[0]).length === 0
                      ? []
                      : columnsData2
                  }
                  etcProps={{ popupParent: parentref }}
                  events={{
                    onBtnAddClick: onGridBtnClick,
                  }}
                />
              </div>
            </div>,
          ]}
          header={[
            <div ref={parentref} className="flex items-center justify-between">
              {/* 좌측: 검색 및 SnTextBox */}
              <div className="flex items-center">
                <span className="mr-8">검 색</span>
                <div className="w-[300px]">
                  <TextField
                    fullWidth
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        style: {
                          height: StyleSettings.control_height,
                          fontSize: StyleSettings.font,
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        search((e.target as HTMLInputElement).value);
                      }
                    }}
                  />
                </div>
              </div>
              {/* 우측: IconButton들 */}
              <div className="flex items-center">
                <div className="ml-2">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("addRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/new_off.svg)",
                      backgroundSize: "cover",
                      width: 30,
                      height: 30,
                      "&:hover": {
                        backgroundImage: "url(/images/new_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
                <div className="ml-5 mr-4">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("deleteRow");
                    }}
                    sx={{
                      backgroundImage: "url(/images/delete_off.svg)",
                      backgroundSize: "cover",
                      width: 25,
                      height: 25,
                      "&:hover": {
                        backgroundImage: "url(/images/delete_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
              </div>
            </div>,
            <div></div>,
            <div ref={parentref2} className="flex items-center justify-between">
              {/* 좌측: 검색 및 SnTextBox */}
              <div className="flex items-center">
                <span className="mr-8">버튼추가</span>
                <div className="w-[300px]">
                  <TextField
                    fullWidth
                    slotProps={{
                      input: {
                        autoComplete: "off",
                        style: {
                          height: StyleSettings.control_height,
                          fontSize: StyleSettings.font,
                        },
                      },
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        addButton((e.target as HTMLInputElement).value);
                      }
                    }}
                  />
                </div>
              </div>
              {/* 우측: IconButton들 */}
              <div className="flex items-center">
                <div className="ml-2">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("addRow2");
                    }}
                    sx={{
                      backgroundImage: "url(/images/new_off.svg)",
                      backgroundSize: "cover",
                      width: 30,
                      height: 30,
                      "&:hover": {
                        backgroundImage: "url(/images/new_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
                <div className="ml-5 mr-4">
                  <IconButton
                    onClick={() => {
                      onGridBtnsClick("deleteRow2");
                    }}
                    sx={{
                      backgroundImage: "url(/images/delete_off.svg)",
                      backgroundSize: "cover",
                      width: 25,
                      height: 25,
                      "&:hover": {
                        backgroundImage: "url(/images/delete_on.svg)",
                        transform: "scale(1.2)",
                        transition: "all 0.3s ease",
                      },
                    }}
                  ></IconButton>
                </div>
              </div>
            </div>,
          ]}
        />
      </div>
    );
  }
);

export default DesignerGridEdit;
